// extracted by mini-css-extract-plugin
export default {"container":"_ContentContainerStyles_container__R8Siu"};